import React, { useState } from 'react';
import './About.css';

const faqData = [
    {
        question: "How many proximity labeling experiments were conducted?",
        answer: "This rich dataset contains 65 proximity labeling experiments on Jurkat cells and 20 proximity labeling experiments on Daudi cells. This represents the richest cell surface proximity labeling information collected so far."
    },
    {
        question: "How was the mass spectrometry data acquired?",
        answer: "The mass spectrometry data was all collected using data independent acquisition (DIA) on an Orbitrap Fusion tribrid mass spectrometer. Importantly, the spectral library was constructed using gas phase fractionation providing a deep coverage of the surface proteome for the cell lines used."
    },
    {
        question: "How can I access the raw data?",
        answer: "All acquired mass spectrometry files can be found on ProteomeXchange with accession number PXD060303"
    }
]

function About() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="about-container flex flex-col items-center space-y-6">
            <h6 className="text-2xl text-[#9b4819] text-serif">
                Proteins located on the plasma membrane and exposed to the extracellular space, collectively known as the surfaceome, are critical for a variety of cellular processes ranging from immune recognition to cell-cell adhesion. This study provides the first comprehensive analysis of the cell surface proteome of immune cells.
            </h6>
            <p className="text-base">
                The data collection and data collection for the cell surface map was done by the Bertozzi Lab and spearheaded by Dr. Brendan Floyd. The surfaceome of Jurkat and Daudi cells was profiled using proximity labeling proteomics and this website provides visual and numerical information on the collected surfaceome data.
            </p>
            <h6 className="text-lg text-[#9b4819] text-serif">
                The aim of this website to aid researchers in identifying targets for experimental protocols, drug development, and therapeutics.
            </h6>

            {/* Steps Section */}
            <h2 className="text-3xl font-bold text-serif"> How Was the Data Collected?</h2>
            <img src="/aboutfigure.jpg" alt="Proximity Labeling Steps" className="step-image"/>

            <div className="steps-section">
                <div className="step">
                    <h2><i>Step 1:</i></h2>
                    <p>Antibodies were used to target an enzyme to a target surface protein for proximity labeling.</p>
                </div>
                <div className="step">
                    <h2><i>Step 2:</i></h2>
                    <p>An optimized mass spectrometry method was used to quantify proximal proteins.</p>
                </div>
                <div className="step">
                    <h2><i>Step 3:</i></h2>
                    <p>Machine learning and network analysis were used for analysis and visualization.</p>
                </div>
            </div>

            {/* FAQ Section */}
            <div className="faq-container mx-auto max-w-[800px] text-left">
                <h1 className="text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                {faqData.map((item, index) => (
                    <div
                        key={index}
                        className="faq-item border-b pb-4 mb-4 w-full"
                    >
                        {/* Question Section */}
                        <div
                            className="faq-question flex justify-between items-center cursor-pointer font-medium text-lg"
                            onClick={() => toggleFAQ(index)}
                        >
                            {item.question}
                            <i
                                className={`fa-solid fa-angle-down transition-transform duration-300 ${
                                    openIndex === index ? 'rotate-180' : ''
                                }`}
                            ></i>
                        </div>

                        {/* Answer Section */}
                        <div
                            className={`faq-answer overflow-hidden transition-[max-height,opacity] duration-300 ease-in-out ${
                                openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                            }`}
                        >
                            <p className="mt-2 text-gray-700">{item.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default About;